export default "__VITE_ASSET__UDvmbvdV__"